import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <a href="mailto:contact@mariemercier.studio" className="footer-email">
          contact@mariemercier.studio
        </a>
        <p className="footer-copyright">
          © {currentYear} Marie Mercier
        </p>
      </div>
    </footer>
  );
}

export default Footer;

